<template>
  <img :src="getProfilePicUrlForClub(club)" :height=size class="club-pic" referrerPolicy="no-referrer">
</template>


<script>

export default {
  name: "ClubPicture",
  props: ['club', 'size'],
  data() {
    return {
    }
  },
  methods: {
    getProfilePicUrlForClub() {

      if ( !this.club.picture_url ) {
        return "";
      }
      return `${this.club.picture_url}?t=${Date.now()}`;
    },
  },
}
</script>


<style scoped>

.profile-picture-component {
  position: relative;
  width: fit-content;
  /*background-color: #01b4e4;*/
}

img {
  border-radius: 20%;
  border-style: solid;
  border-width: 0.1px;
  border-color: lightgrey;
}

</style>